import { useMemo } from 'react';

const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);

const transformCategory = (category) => {
    const result = [{
        display: "All",
        payload: "",
    }];

    category?.forEach((item) => {
      result.push({
        display: capitalize(item.name),
        payload: item.name,
      });
    });

    return result;
};


export const useTransformedBillers = (categoryName, data = []) => {
  return useMemo(() => {
    if (!data[categoryName]) {
      return [];
    }
    return transformCategory(data[categoryName]);
  }, [categoryName, data]);
};
